import SEO from '../components/SEO';
import HeroSection from '../components/HeroSection';
import contactHero from '../assets/images/hero/contact.png';
import { FaMapMarkerAlt, FaEnvelope, FaPhone, FaClock } from 'react-icons/fa';

const Contact = () => {
  return (
    <div>
      <SEO 
        title="Contact Us | Grace Super Market Chennai"
        description="Get in touch with Grace Super Market. Find our store locations, contact details, and head office information. We're here to help!"
        keywords="contact Grace Super Market, supermarket locations, Chennai stores, customer service"
        ogImage={contactHero}
        canonicalUrl={`${process.env.REACT_APP_CURRENT_URL}/contact`}
      />
      <HeroSection 
        title="Contact Us" 
        description="We'd Love to Hear From You"
        image={contactHero}
      />
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-6 md:px-20">
          <div className="max-w-5xl mx-auto">
            <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12 mb-12">
              <h2 className="text-3xl font-semibold mb-8 text-center">Head Office</h2>
              
              <div className="grid md:grid-cols-2 gap-8 mb-12">
                <div className="space-y-6">
                  <div className="flex items-start space-x-4">
                    <FaMapMarkerAlt className="text-green-600 text-2xl mt-1 flex-shrink-0" />
                    <div>
                      <h3 className="font-semibold text-lg mb-2">Address</h3>
                      <p className="text-gray-600 leading-relaxed">
                        Grace Super Market<br />
                        21 /4 B2, Noombal Rd, Numbal, Kattupakkam,<br />
                        Puliambedu, Chennai, Tamil Nadu 600077
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start space-x-4">
                    <FaEnvelope className="text-green-600 text-2xl mt-1 flex-shrink-0" />
                    <div>
                      <h3 className="font-semibold text-lg mb-2">Email</h3>
                      <a href="mailto:customercare@gracesupermarket.com" 
                         className="text-green-600 hover:underline">
                        customercare@gracesupermarket.com
                      </a>
                    </div>
                  </div>

                  <div className="flex items-start space-x-4">
                    <FaPhone className="text-green-600 text-2xl mt-1 flex-shrink-0" />
                    <div>
                      <h3 className="font-semibold text-lg mb-2">Phone</h3>
                      <a href="tel:6033360333" 
                         className="text-green-600 hover:underline">
                        6033360333
                      </a>
                    </div>
                  </div>

                  <div className="flex items-start space-x-4">
                    <FaClock className="text-green-600 text-2xl mt-1 flex-shrink-0" />
                    <div>
                      <h3 className="font-semibold text-lg mb-2">Working Hours</h3>
                      <p className="text-gray-600">
                        Monday - Saturday<br />
                        10:00 AM - 6:00 PM
                      </p>
                    </div>
                  </div>
                </div>

                <div className="h-full min-h-[300px] rounded-xl overflow-hidden shadow-lg">
                  <iframe 
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4757.6103238445885!2d80.12716212168621!3d13.05052692689!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a5261a330be89e9%3A0xc9ad31645c7ad1fa!2sGrace%20Super%20Market!5e0!3m2!1sen!2sin!4v1746630807841!5m2!1sen!2sin"
                    width="100%"
                    height="100%"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    className="w-full h-full"
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;